import React from "react";

/**
 * Skeleton primitives (Phase 9 — Safe Zap v2.0).
 * Usa classe `.skeleton` já existente em styles.css (shimmer 1.6s).
 */

export function SkeletonBlock({ width = "100%", height = 16, radius, style = {}, className = "" }) {
  return (
    <span
      className={`skeleton ${className}`}
      style={{
        width: typeof width === "number" ? `${width}px` : width,
        height: typeof height === "number" ? `${height}px` : height,
        borderRadius: radius != null ? (typeof radius === "number" ? `${radius}px` : radius) : undefined,
        ...style,
      }}
    />
  );
}

export function SkeletonAvatar({ size = 32 }) {
  return <SkeletonBlock width={size} height={size} radius="50%" />;
}

export function SkeletonText({ lines = 1, lastWidth = "60%", gap = 6 }) {
  if (lines <= 1) return <SkeletonBlock />;
  return (
    <div style={{ display: "flex", flexDirection: "column", gap }}>
      {Array.from({ length: lines }).map((_, i) => (
        <SkeletonBlock key={i} width={i === lines - 1 ? lastWidth : "100%"} />
      ))}
    </div>
  );
}

/**
 * SkeletonList — N linhas com avatar + título + sub-linha.
 * Use em listas verticais simples (Tickets, Chatbots, Automações).
 */
export function SkeletonList({ rows = 6, withAvatar = true, className = "" }) {
  return (
    <div className={`uiSkeletonList ${className}`}>
      {Array.from({ length: rows }).map((_, i) => (
        <div className="uiSkeletonRow" key={i}>
          {withAvatar && <SkeletonAvatar size={36} />}
          <div className="uiSkeletonRowBody">
            <SkeletonBlock width={`${55 + (i * 7) % 30}%`} height={14} />
            <SkeletonBlock width={`${30 + (i * 11) % 25}%`} height={11} />
          </div>
        </div>
      ))}
    </div>
  );
}

/**
 * SkeletonTable — N linhas com colunas configuráveis.
 * columns: número de colunas a renderizar. Distribui largura uniformemente.
 */
export function SkeletonTable({ rows = 5, columns = 4, withAvatar = false }) {
  return (
    <div className="uiSkeletonTable">
      {Array.from({ length: rows }).map((_, r) => (
        <div className="uiSkeletonTableRow" key={r}>
          {withAvatar && <SkeletonAvatar size={28} />}
          {Array.from({ length: columns }).map((_, c) => (
            <SkeletonBlock
              key={c}
              width={c === 0 ? "70%" : c === columns - 1 ? "40%" : "55%"}
              height={12}
            />
          ))}
        </div>
      ))}
    </div>
  );
}
